import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { authReducer } from './auth/auth.reducer';
import { locationsReducer } from './locations/locations.reducer';
import { AuthState } from './auth/auth.state';
import { LocationsState } from './locations/locations.state';
import { environment } from '../../environments/environment';

export interface AppState {
  auth: AuthState;
  locations: LocationsState;
}

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  locations: locationsReducer
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];